<template>

  <div class="flex flex-col justify-center items-center mt-10">

      <!-- <div class="flex-col justify-center content-center items-baseline mt-4 lg:mt-10">

          <img class="rounded-full p-4 lg:p-8 object-cover bg-white h-32 w-32 lg:h-64 lg:w-64" src="@/assets/images/full-logo.jpg">
      </div> -->

      <div class="mt-8 lg:mt-20 p-5 lg:p-10 bg-blue-300 rounded-full border-red-800 border-4">

        <label>{{$t('payment.failedPayment')}}</label>
      </div>
  </div>
</template>

<script>
export default {

  mounted(){

    const route = this.$router;

    setTimeout(function(){

        route.replace({ path: '/packages', query: { redirected: 'false' }});
        }, 10000);
  }

}
</script>

<style>

</style>